import { render, staticRenderFns } from "./administrationLandingPageCreator.vue?vue&type=template&id=948314b4&"
import script from "./administrationLandingPageCreator.vue?vue&type=script&lang=js&"
export * from "./administrationLandingPageCreator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports